import React from 'react';
import { Box, Typography } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { useTranslation } from 'react-i18next';
import { IPodiumEmptyPlaceholder } from './interfaces';

export const PodiumEmptyPlaceholder: React.FC<IPodiumEmptyPlaceholder> = ({
  enrollmentCount,
}): JSX.Element => {
  const { t } = useTranslation();

  const subTitleKey =
    enrollmentCount === 0
      ? 'competitions:portal.results.podium.empty.noParticipantsSubTitle'
      : 'competitions:portal.results.podium.empty.subTitle';

  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        minHeight: 108,
        py: 2,
        px: 1.5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '10px',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(8px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
      }}
    >
      <EmojiEventsIcon
        sx={{
          fontSize: 28,
          color: 'rgba(255, 255, 255, 0.85)',
          mb: 0.75,
        }}
      />

      <Typography
        sx={{
          color: '#fff',
          textAlign: 'center',
          fontSize: '0.9rem',
          fontWeight: 600,
          lineHeight: 1.1,
          mb: 0.25,
        }}
      >
        {t('competitions:portal.results.podium.empty.title')}
      </Typography>

      <Typography
        sx={{
          color: 'rgba(255, 255, 255, 0.75)',
          textAlign: 'center',
          fontSize: '0.75rem',
          lineHeight: 1.2,
        }}
      >
        {t(subTitleKey)}
      </Typography>
    </Box>
  );
};
